import React from "react";
import bloglogo from "../images/bloglogo.svg";
import { Description, Section } from "../styles";
import styled from "styled-components";
import { Link } from "react-router-dom";
const BlogSection = () => {
  return (
    <Link
      style={{ textDecoration: "none", color: "black" }}
      className="link"
      to="/blogs"
    >
      <SectionBlog>
        <DescriptionBlog>
          <h2>
            My <span>Blogs</span>
          </h2>
          <p>
            I generally write about technical content and as well as Some non
            technical stuffs, check them out here
          </p>
        </DescriptionBlog>
        <div className="image-div">
          <img src={bloglogo} alt="" />
        </div>
      </SectionBlog>
    </Link>
  );
};

const SectionBlog = styled(Section)`
  margin: 4rem 2rem;
  padding: 1rem;
  overflow: hidden;
`;
const DescriptionBlog = styled(Description)`
  p {
    padding: 1rem 1rem 1rem 0rem;
    font-size: 1.2rem;
  }
  margin-top: -4rem;
  padding: 2rem;
  margin-left: 2rem;
  h2 {
    font-size: 240%;
    span {
      color: #8b73ff;
    }
  }
`;
export default BlogSection;
